import { Partners } from '../types/partners'

export const isPartner = (value: string): value is Partners =>
  value !== Partners.DEFAULT && Object.values(Partners).includes(value as Partners)
